"use client"

import type { DataImportStatistics } from "@/schema/data-import"
import { CheckCircle2 } from "lucide-react"

interface ImportCompleteSummaryProps {
  statistics: DataImportStatistics | null
}

export function ImportCompleteSummary({ statistics }: ImportCompleteSummaryProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <CheckCircle2 className="text-green-accent mb-4 h-16 w-16" />
      <h3 className="mb-2 text-xl font-semibold">Import complete</h3>
      {statistics ? (
        <>
          <p className="text-muted-foreground mb-4 text-center">Your data has been imported into your book.</p>
          <div className="mb-6 grid w-full max-w-xs grid-cols-2 gap-2">
            {(
              [
                ["Clients", statistics.clients_count],
                ["Prospects", statistics.prospects_count],
                ["Past clients", statistics.past_clients_count],
                ["Other contacts", statistics.other_contacts_count],
              ] as const
            ).map(([label, count]) => (
              <div key={label} className="bg-muted rounded-md p-3 text-center">
                <div className="text-xl font-semibold">{count ?? 0}</div>
                <div className="text-muted-foreground text-xs">{label}</div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="text-muted-foreground mb-6 text-center">
          This import has already been completed.
          <br />
          Your data has been imported into your book.
        </p>
      )}
    </div>
  )
}
